<div mat-dialog-content>
    <div class="body-preview">
        <div class="title-preview">
            <h1>Pré-visualização {{this.title}}</h1>
        </div>
        <hr/>
        <iframe class="iframe-preview" [src]="this.url" allow="camera;microphone" title="Preview"></iframe>
        <button mat-flat-button color="primary" class="button-close-modal" (click)="close()">Ok</button>
    </div>
</div>